import Vue from "vue";
import VueRouter from "vue-router";
// import store from './store'
// import {
//     api
// } from '@/require/api'
Vue.use(VueRouter);

const routes = [{
        path: "/",
        name: "Home",
        component: resolve => require(["./views/home.vue"], resolve),
    }, {
        path: "/about",
        name: "About",
        component: resolve => require(["./views/about.vue"], resolve),
    }, {
        path: "/news",
        name: "News",
        component: resolve => require(["./views/news.vue"], resolve),
    },
    {
        path: "/party",
        name: "Party",
        component: resolve => require(["./views/party.vue"], resolve),
    },
    {
        path: "/recruit",
        name: "Recruit",
        component: resolve => require(["./views/recruit.vue"], resolve),
    },
    {
        path: "/solution",
        name: "Solution",
        component: resolve => require(["./views/solution.vue"], resolve),
    },
    {
        path: "/partner",
        name: "Partner",
        component: resolve => require(["./views/partner.vue"], resolve),
    },
    {
        path: "/contact",
        name: "Contact",
        component: resolve => require(["./views/contact.vue"], resolve),
    },
    {
        path: "/search",
        name: "Search",
        component: resolve => require(["./views/search.vue"], resolve),
    }, {
        path: "/detail",
        name: "Detail",
        component: resolve => require(["./views/detail.vue"], resolve),
    },
    {
        path: "/product_service",
        name: "Product_service",
        component: resolve => require(["./views/product_service.vue"], resolve),
        children: [{
                path: '/product_service/data',
                component: resolve => require(["./views/product_services/data.vue"], resolve),
                name: 'data',
            },
            {
                path: '/product_service/research',
                component: resolve => require(["./views/product_services/research.vue"], resolve),
                name: 'research',
            },
            {
                path: '/product_service/infor',
                component: resolve => require(["./views/product_services/infor.vue"], resolve),
                name: 'infor',
            }
        ]
    },
    {
        path: `/customer/:tab`,
        name: "customer",
        component: resolve => require(["./views/customer.vue"], resolve),
    },
    {
        path: "/links",
        name: "links",
        component: resolve => require(["./views/links.vue"], resolve),
    },
    {
        path: "/window",
        name: "window",
        component: resolve => require(["./views/window.vue"], resolve),
    }
]

const router = new VueRouter({
    routes
});
// router.beforeEach((to, from, next) => {
//     // 特殊要求（只能调用一次顶部菜单接口），所以放在进入路有前调用
//     if (store.state.indexMenus.length === 0) {
//         api.get(
//             "/cmsfront/IndexController/getIndexMenuById", {
//                 menuId: "1453963868773634049",
//                 onlyChild: false,
//                 paltformId: "1453963868773634049"
//             }
//         ).then(res => {
//             if (res.code === 0) {
//                 store.commit("updateIndexMenus", res.data.childrenList);
//             }
//             next()
//             // console.log(store.state.indexMenus)
//         })

//     } else {
//         next()
//         // console.log(store.state.indexMenus)
//     }
// })
export default router;